import axios from "axios";

const API_URL = process.env.VUE_APP_ROOT_API;

export default axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});
